import { EventEmitter } from '@angular/common/src/facade/async';
import { Component, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { ChangeBillingStatusService } from './change-billing-status.service';
import { constant } from '../../../app.constants';
import { IChangeBillingTrip } from '../../../core/interfaces/change-billing-status-trips.interface';
import { BillingStatusEnum } from '../../../core/enums/billing-status.enum';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';

@Component({
  selector: 'app-change-billing-status-trip',
  templateUrl: './change-billing-status-trip.component.html',
  styleUrls: ['./change-billing-status-trip.component.scss']
})
export class ChangeBillingStatusTripComponent implements OnInit, OnChanges {

  @Output() eventEmitter: EventEmitter<IChangeBillingTrip> = new EventEmitter<IChangeBillingTrip>();
  @Input() tripsIds?: any;
  @Input() currentTab? = 0;
  @Input() resetForm: number;
  tabsUnverifiedTrips = constant.UNVERIFIED_TRIPS.TABS_UNVERIFIED_TRIPS;
  billingStatusId;
  noteChangeStatus = '';

  constructor(protected service: ChangeBillingStatusService,
              protected _loading: T2LoadingService, private toastrAlertHelper: ToastrAlertHelper) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['resetForm']) {
      this.billingStatusId = null;
      this.noteChangeStatus = '';
    }
  }

  validateTripsToExport(): void {
    this._loading.show();

    const OBJ_REQUEST = {
      tripstochange: this.tripsIds,
      billingstatusid: Number(this.billingStatusId),
      note: this.noteChangeStatus ? this.noteChangeStatus.trim() : '',
    };

    this.service
      .changeBillingStatusTrip(OBJ_REQUEST)
      .finally(() => {
        this._loading.hiden();
        this.billingStatusId = null;
        this.noteChangeStatus = '';
      }).subscribe(
      success => {
        this.eventEmitter.emit({
          successRequest: true,
          errorRequest: false,
          response: success,
          btnClickClose: false
        });
      },
      error => {
        this.toastrAlertHelper.error(error.message);
      }
    );
  }

  closeModal(): void {
    this.billingStatusId = null;
    this.noteChangeStatus = '';
    this.eventEmitter.emit({
      btnClickClose: true
    });
  }

  getBillingStatusList(all: boolean, typeList?: number): { typeList: number; name: string; value: BillingStatusEnum }[] {
    return constant.UNVERIFIED_TRIPS.NEXT_BILLING_STATUS_LIST.filter((f) => {
      return all ? f.value !== 3 && f.value !== 1 : f.typeList === typeList || f.value === 2 ;
    });
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/change-billing-status-trip/change-billing-status-trip.component.ts